import store from '@/store/index';

import {extractTextFromExcel} from './ function_process/excelProcessor';
import {getFileObjByPath} from "../../../utils/getFileObj"

import {uploadOssFile} from "@/api/oss"

import {getImgMatch} from "@/api/match_api";


const urlToBlob = async (url) => {
    // 使用 fetch API 可以优雅地处理 data: 和 blob: 协议的 URL
    const response = await fetch(url);
    if (!response.ok) {
        throw new Error(`Failed to fetch blob from URL: ${url}`);
    }
    return await response.blob();
};

export const uploadUrlToOSS = async (project_id, url, imageName) => {
    try {
        const fileBlob = await urlToBlob(url);
        const contentType = fileBlob.type || 'application/octet-stream';

        const result = await uploadOssFile(project_id, imageName, fileBlob, contentType);
        if (result.error) {
            if (result.status === 400 && result.message === 'Key already exists') {
                // 预期错误：文件已存在，根据业务逻辑可以视为成功
                console.log(`Thumbnail '${imageName}' already exists in project_id '${project_id}'. Skipping.`);
                return { "res": "ok", "error": null };
            } else {
                return { "res": "err", "error": result.message };
            }
        } else {
            return { "res": "ok", "data": result.data };
        }
    } catch (error) {
        console.error(`Error uploading thumbnail '${imageName}' to OSS:`, error);
        throw error;
    }
};

export const uploadFileToOSS = async (bucketName, fileInfo) => {
    try {
        const uint8Array = await window.electronAPI.getFileBinary(fileInfo.file_path);
        const fileBlob = new Blob([uint8Array]);
        const contentType = 'text/plain'

        const result = await uploadOssFile(bucketName, fileInfo.file_key, fileBlob, contentType);
        if (result.error) {
            if (result.status === 400 && result.message === 'Key already exists') {
                return {"res": "ok", "error": null}
            } else{
                return {"res": "err", "error": result.message}
            }
        } else {
            // 上传成功，处理结果
            return {"res": "ok", "data": result.data}
        }
    } catch (error) {
        console.error("Error uploading file to OSS:", error);
        throw error;
    }
};

export async function getImgMatchByKey(tableKey, projectId, fileKey, keywords, user = "test") {
    const reqData = {
        "file_name": fileKey,
        "file_key": fileKey,
        "user": user,
        "project_id": projectId,
        "table_key": tableKey,
        "keywords": keywords
    }

    return await getImgMatch(reqData)
}